export default function Policies() {
    return (
        <div className="align-items-center justify-content--center ">
            <div className="text-center text-2xl font-bold" style={{ paddingTop: '20rem'}}>
                Policy Page
            </div>
        </div>
    );
}